import {BaseContainerModel} from '../base-container.model';
import {bl_asv_checklist_hdr_RowClass} from '../../dbschema';

export class AsvCheckListHdrModel extends BaseContainerModel {
    bl_asv_checklist_hdr: bl_asv_checklist_hdr_RowClass = new bl_asv_checklist_hdr_RowClass();
}